<script lang="ts">
  // The definitions a line sits in, outer first: `mod tests › fn freezes`.
  // Outer scopes give up their width before the innermost one. Test code is
  // tagged once, at the outermost test scope (everything inside it is test
  // code too). Given `onpick`, each name is a button that goes to its
  // definition, and `onpeek` is told while one is hovered or focused (with
  // its button), and null when it no longer is.
  import type { Scope } from '../engine/types';

  interface Props {
    scopes: readonly Scope[];
    onpick?: (scope: Scope) => void;
    onpeek?: (peek: { scope: Scope; el: HTMLElement } | null) => void;
  }
  let { scopes, onpick, onpeek }: Props = $props();

  const firstTest = $derived(scopes.findIndex((s) => s.test));
</script>

<span class="scope-path">
  {#each scopes as s, i (i)}
    {#if i > 0}<span class="scope-sep" aria-hidden="true">›</span>{/if}
    {#if onpick}
      <button
        type="button"
        class="scope scope-go"
        class:inner={i === scopes.length - 1}
        title="Go to {s.title} (line {s.headLine})"
        onclick={() => onpick(s)}
        onpointerenter={(e) => onpeek?.({ scope: s, el: e.currentTarget })}
        onpointerleave={() => onpeek?.(null)}
        onfocus={(e) => onpeek?.({ scope: s, el: e.currentTarget })}
        onblur={() => onpeek?.(null)}>{s.title}</button
      >
    {:else}
      <span class="scope" class:inner={i === scopes.length - 1}>{s.title}</span>
    {/if}
    {#if i === firstTest}<span class="scope-test" title="Test code">test</span>{/if}
  {/each}
</span>
